import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminSidebar from '../../components/admin/AdminSidebar';
import { ADMIN_NAVIGATION_LINKS } from '../../constants';
import { useTheme } from '../../contexts/ThemeContext';

const AdminLayout: React.FC = () => {
  const { colors } = useTheme();
  const location = useLocation();
  const currentAdminPage = ADMIN_NAVIGATION_LINKS.find(link => location.pathname.startsWith(link.path));
  const pageTitle = currentAdminPage ? currentAdminPage.label : 'Admin';

  return (
    <div className="flex h-screen" style={{ backgroundColor: colors.background.default }}>
      <AdminSidebar />
      <div className="flex-1 flex flex-col overflow-hidden ml-64"> {/* Adjust ml to match sidebar width */}
        <header className="shadow-md p-4" style={{ backgroundColor: colors.background.paper }}>
          <h1 className="text-2xl font-semibold" style={{ color: colors.text.primary }}>{pageTitle}</h1>
        </header>
        <main className="flex-1 overflow-x-hidden overflow-y-auto p-6" style={{ backgroundColor: colors.background.default }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;